import React, { useEffect, useRef, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "../../api/axios";
import { destroySession } from "../../helpers/Session";
import { NavLink, useNavigate } from "react-router-dom";

const Year = () => {
    const navigate = useNavigate();

    const timeoutRef = useRef(null);
    
    const accesstoken = sessionStorage.getItem('accesstoken');
    const uname = sessionStorage.getItem('uname'); 

    const breadcrumbChildSlug = sessionStorage.getItem('timesheetChildSlug') || ('');
    
    const [accessibleDepartments, setAccessibleDepartments] = useState([]);

    const { data: role } = useQuery({
        queryKey: ['userrole']
    });

    const { data: manageddepartments = [] } = useQuery({
        queryKey: ['managedDepartments', uname]
    });

    const { data: managedadjustments = [] } = useQuery({
        queryKey: ['managedAdjustments', uname]
    });
    
    useEffect(() => {
        const combineDepartments = [...manageddepartments, ...managedadjustments];
        const finalDepartments = combineDepartments.filter((value, index, self) => (
            index === self.findIndex((d) => (
                d.department_code === value.department_code && d.department === value.department
            ))
        ));

        if (JSON.stringify(finalDepartments) !== JSON.stringify(accessibleDepartments)) {
            setAccessibleDepartments(finalDepartments);
        }
    }, [manageddepartments, managedadjustments, accessibleDepartments]);

    const { data: years, isLoading: isLoadingYears, error: errorYears } = useQuery({
        queryKey: ['payperiodyears'],
        queryFn: async () => {
            const res = await axios.get('payperiods/years', {
                headers: { 'Authorization': `Bearer ${accesstoken}` }
            });
            return res.data.response;
        },
        enabled: !!accesstoken,
        retry: 1
    });

    useEffect(() => {
        if (errorYears?.response?.data.status === 'inactive') {
            destroySession();
            clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(() => { navigate('/error'); }, 1000);
        }
    }, [errorYears, navigate]);

    const handleSetTimesheetGrandchildData = (year) => {
        // MSW-26192: Clear employee data when navigating to a different year
        sessionStorage.removeItem('timesheetEmployee');
        sessionStorage.removeItem('timesheetEmployeeUname');

        if ((role === 'admin' || role === 'management') || manageddepartments?.length > 1 || managedadjustments?.length > 1) {
            sessionStorage.setItem('timesheetGrandchild', year);
            sessionStorage.setItem('timesheetGrandchildSlug', year);
        } else {
            sessionStorage.setItem('timesheetChild', year);
            sessionStorage.setItem('timesheetChildSlug', year);
        }
    };

    return (
        <div className={`years card ${isLoadingYears && ' loading'}`}>
            {isLoadingYears ? (
                [...Array(8)].map((_, i) => (
                    <div className="card-content" key={i}>
                        <a>
                            <i className="fa fa-folder"></i>
                            <span>Loading...</span>
                        </a>
                    </div>
                ))
            ) : (
                years?.map((item) => (
                    <div className="card-content" key={item.id}>
                        <NavLink 
                            to={(role === 'admin' || role === 'management' ) || manageddepartments?.length > 1 || managedadjustments?.length > 1 ? `/dtr/timesheets/${breadcrumbChildSlug}/${item.year}` : `/dtr/timesheets/${item.year}`} 
                            title={item.year} 
                            onClick={() => handleSetTimesheetGrandchildData(item.year)}
                            aria-label={`Navigate to timesheets for ${item.year}`}
                        >
                            <i className="fa fa-folder"></i>
                            <span>{item.year}</span>
                        </NavLink>
                    </div>
                ))
            )}
        </div>
    );
};

export default Year;
